import { get } from '../index';

export const getDiscipline = (company) => {
  return get(`/discipline/?company=${company}`);
};
